import { useState } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../../src/app/store";

import ButtonV2 from "../../../../../src/components/ui/button/v2";
import StageWorkflowConfirmCaseProgressionModal from "../../../../../src/features/stageWorkflow/components/StageWorkflowConfirmCaseProgressionModal";

import {
  CaseStageAction,
  CaseStageEnum,
} from "../../../../../src/api/caseStages";

import { updateCaseStage } from "../../../../../src/features/caseStages/logic/thunks";
import { selectStageConfigByStage } from "../../../../../src/features/caseStages/logic/slice";

import { useLoggedInUserId } from "../../../../../src/features/auth/logic/rbac";
import { selectParticipantByType } from "../../../../../src/features/caseinfo/logic/ParticipantsSlice";
import { ParticipantType } from "../../../../../src/api/participants";


import { showErrorToast, showSuccessToast } from "../../../../../src/lib/toast";
import { getAppointingAuthAssessmentState, getZonalCommitteeAssessmentState } from "../../../../../src/features/reporting/components/ObservationsByAuthority/logic/ObservationsByAuthoritySlice";
import { selectCurrentCaseStage } from "../../../../../src/features/caseinfo/logic/Slice";

export const IOAppAuthSubmitAssessmentStageButton: React.FC = () => {
  const { id: caseId } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const loggedInUserId = useLoggedInUserId();

  const ioAppAuthParticipant = useAppSelector((state) =>
    selectParticipantByType(state, ParticipantType.IO_APPOINTING_AUTHORITY)
  );

  const isIOAppointingAuthority =
    loggedInUserId === ioAppAuthParticipant?.participant_id;

  const zonal = useAppSelector(getZonalCommitteeAssessmentState);
  const appointing = useAppSelector(getAppointingAuthAssessmentState);

  const hasObservationData =(zonal?.ids?.length ?? 0) > 0 || (appointing?.ids?.length ?? 0) > 0;

  const currentStage = useAppSelector(selectCurrentCaseStage);
  const isCorrectStage = currentStage?.stage === CaseStageEnum.IO_APP_AUTH_SUBMIT_ASSESSMENT;

  const stageConfig = useAppSelector(
    selectStageConfigByStage(CaseStageEnum.IO_APP_AUTH_SUBMIT_ASSESSMENT)
  );

  const nextStage = stageConfig?.actions?.find(
    (a) => a.action === CaseStageAction.SUBMIT_POST_IR_ASSESSMENT
  )?.next_stage;


  const isVisible =isIOAppointingAuthority &&  hasObservationData && isCorrectStage && nextStage;

  if (!isVisible) return null;

  const handleConfirm = async (remarks?: string) => {
    if (!caseId || !nextStage) return;

    try {
      setIsLoading(true);

      const request = {
        stage: nextStage,
        source_action: CaseStageAction.SUBMIT_POST_IR_ASSESSMENT,
        stage_data: {
          notes: remarks,
        },
      };

      await dispatch(updateCaseStage({ caseId, request })).unwrap();

      showSuccessToast("Assessment submitted successfully");
      setIsOpen(false);
    } catch (error) {
      showErrorToast("Failed to submit assessment");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <ButtonV2
        variant="primary"
        size="md"
        onClick={() => setIsOpen(true)}
        className="h-[36px] px-4 py-2 rounded-md shadow-[0px_1px_2px_rgba(0,0,0,0.05)]"
      >
        Submit
      </ButtonV2>

      <StageWorkflowConfirmCaseProgressionModal
        isOpen={isOpen}
        nextStage={nextStage!}
        onClose={() => !isLoading && setIsOpen(false)}
        onConfirm={handleConfirm}
        primaryDisabled={isLoading}
        primaryLoading={isLoading}
        title="Submit Report"
        description="You are completing the actions assigned to you"
      />
    </>
  );
};